import { Title as Container } from "./styles";

export function SelectTitle({ children }) {
  return <Container>{children}</Container>;
}
